//import Vue from "vue";
import * as types from "./mtypes";

export default {
  //Get Accounts
  [types.FETCH_ACCOUNT_REQUEST](state) {
    state.fetching = true;
    state.error = null;
  },

  [types.FETCH_ACCOUNT_SUCCESS](state, result) {
    state.fetching = false;
    state.error = null;
    state.accountList = result;
  },

  [types.FETCH_ACCOUNT_FAILURE](state, error) {
    state.fetching = false;
    state.error = error;
    state.accountList = [];
  },

  [types.FETCH_ALL_ACCOUNT_SUCCESS](state, result) {
    state.fetching = false;
    state.loading = false;
    state.allAccounts = result?.data;
  },

  [types.FETCH_PLAIN_PASSWORD](state, result) {
    state.fetching = false;
    state.passwordResponse = result;
  },

  [types.RESET_PASSWORD](state, result) {
    state.fetching = false;
    state.isSucceeded = result.succeeded;
    state.resetResponse = result;
  },

  [types.REQUEST_HANDLER](state) {
    state.loading = true;
  },

  [types.REQUEST_SUCCESS](state, data) {
    state.loading = false;
    state.isSucceeded = data.succeeded;
    state.resultMessage = data.resultMessage;
  },

  [types.REQUEST_FAILURE](state, data) {
    state.loading = false;
    state.isSucceeded = data.Succeeded;
    state.errorCode = data.ErrorCode;
    state.errorMessage = data.ErrorMessage;
    state.validationErrors = data.ValidationErrors;
  },
};
